// extracted by mini-css-extract-plugin
module.exports = {"root":"UVAppBrowserItemSelector_root__2RgkL"};